import loaderSVG from 'assets/loader.svg';

const Spinner = (props) => {
  return (
    <img src={loaderSVG} alt="" {...props} />
  )
}

export default Spinner